module.exports = __webpack_public_path__ + "b5d8d8f1b3a6cb2421a45196c98965da.pdf";